module.exports = __webpack_public_path__ + "static/media/icon_download.4db1cbfd.svg";